import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfflineBaseComponent } from './offline-base.component';


@NgModule({
  declarations: [
    OfflineBaseComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [

  ]
})
export class OfflineBaseModule { }
